import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import AuthStateApp from './AuthStateApp';
import * as serviceWorker from './serviceWorker';

Sentry.init({
    dsn: "https://6f890928f8b643c0ad94bcdb718e031c@o507863.ingest.sentry.io/5605079",
    environment: process.env.REACT_APP_ENV,
    autoSessionTracking: true,
    integrations: [
        new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

ReactDOM.render(
    <React.StrictMode>
        <AuthStateApp/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();